"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseSessionLineItem = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _ObjectDetailBar = require("components/ObjectDetailBar");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _PromiseRenderer = babelHelpers.interopRequireDefault(require("PromiseRenderer"));

var _pie = babelHelpers.interopRequireDefault(require("pie"));

var _compat = require("compat");

var _AnimatedComponent = babelHelpers.interopRequireDefault(require("components/AnimatedComponent"));

var _decorators = require("decorators");

var _class, _descriptor, _temp, _class3, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _temp2, _class5, _descriptor17, _descriptor18, _descriptor19, _temp3, _class7, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _temp4, _class9, _descriptor28, _temp5, _class11, _descriptor29, _temp6;

var CourseSessionLineItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CourseSessionLineItem, _Component);

  function CourseSessionLineItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CourseSessionLineItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CourseSessionLineItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "session", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CourseSessionLineItem, [{
    key: "render",
    value: function render() {
      switch (this.session.child_type) {
        case 'scheduledSession':
          return _react.default.createElement(ScheduledSessionLineItem, this.props);

        case 'oneOnOneSession':
          return _react.default.createElement(OneOnOneSessionLineItem, this.props);
      }

      return null;
    }
  }], [{
    key: "value",
    value: function value(page, props) {
      props = Object.assign({}, props);
      var sp = ['startDate', 'endDate', 'hasRegistrationRange', 'registrationStartDate', 'registrationEndDate', 'notConfirmed', 'dateMessage', 'child_type', 'title'];
      props.session = sp.reduce(function (v, key) {
        return Object.assign(v, babelHelpers.defineProperty({}, key, props.session[key]));
      }, {});
      return props;
    }
  }]);
  return CourseSessionLineItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "session", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.CourseSessionLineItem = CourseSessionLineItem;
var ScheduledSessionLineItem = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ScheduledSessionLineItem, _Component2);

  function ScheduledSessionLineItem() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ScheduledSessionLineItem);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ScheduledSessionLineItem)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "media", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "session", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "user", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "purchase", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "access", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "people", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "button", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "link", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      outlineVisible: false,
      count: 0
    };
    babelHelpers.initializerDefineProperty(_this2, "startDate", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "endDate", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "hasRegistrationRange", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "regStartDate", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "regEndDate", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "dateIsNotConfirmed", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "dateMessage", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.boxStyleMobile = {
      overflow: 'hidden',
      width: '',
      height: '0px',
      opacity: 0,
      marginTop: 0
    };
    _this2.stylesMobile = ['height', 'opacity', 'marginTop'];
    _this2.boxStyleNotMobile = {
      overflow: 'hidden',
      width: '0px',
      height: '',
      opacity: 0
    };
    _this2.stylesNotMobile = ['width', 'opacity'];
    return _this2;
  }

  babelHelpers.createClass(ScheduledSessionLineItem, [{
    key: "getMedia",
    value: function getMedia() {
      try {
        return window.matchMedia('(max-width: 767px)');
      } catch (e) {
        return {
          matches: true,
          addListener: function addListener() {},
          removeListener: function removeListener() {}
        };
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.media.addListener(this.mediaChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.media.removeListener(this.mediaChanged);
    }
  }, {
    key: "buttonMin",
    value: function buttonMin(element) {
      if (this.media.matches) return {
        height: 0,
        opacity: 0,
        marginTop: 0
      };
      return {
        width: 0,
        opacity: 0
      };
    }
  }, {
    key: "buttonMax",
    value: function buttonMax(element) {
      if (this.media.matches) return {
        height: element.style.height != '0px' ? element.offsetHeight : element.scrollHeight,
        opacity: 1,
        marginTop: 1
      };
      return {
        width: element.style.width != '0px' ? element.offsetWidth : element.scrollWidth,
        opacity: 1
      };
    }
  }, {
    key: "buttonFormat",
    value: function buttonFormat(value, name) {
      if (name == 'opacity') return value;

      if (name == 'marginTop') {
        return _compat.Info.cssVariables ? "calc(var(--scalable-unit, 16px) * ".concat(value, " * (18 / 16))") : value * 10 + 'px';
      }

      return "".concat(value, "px");
    }
  }, {
    key: "finishButtonStyle",
    value: function finishButtonStyle(button, targetState) {
      if (!targetState) {
        button.style[this.media.matches ? 'height' : 'width'] = '0px';
        button.style.opacity = 0;
        button.style.marginTop = this.media.matches ? '0px' : '';
      } else {
        button.style.width = button.style.height = '';
        button.style.opacity = 1;

        if (this.media.matches) {
          if (_compat.Info.cssVariables) button.style.marginTop = 'calc(var(--scalable-unit, 16px) * 24 / 16)';else button.style.marginTop = '24px';
        } else {
          button.style.marginTop = '';
        }
      }
    }
  }, {
    key: "mediaChanged",
    value: function mediaChanged() {
      this.setState(function (_ref) {
        var count = _ref.count;
        return {
          count: count + 1
        };
      });
    }
  }, {
    key: "showButton",
    value: function showButton() {
      if (this.purchase) return true;else {
        if (this.hasRegistrationRange) {
          return this.regEndDate.getTime() > Date.now();
        } else {
          return this.endDate.getTime() > Date.now();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("section", {
        className: "course-session scheduled"
      }, _react.default.createElement("div", {
        className: "main"
      }, _react.default.createElement("div", {
        className: "session-info"
      }, this.dateIsNotConfirmed ? _react.default.createElement("div", {
        className: "session-date-range"
      }, _react.default.createElement("span", {
        className: "session-start session-end"
      }, this.dateMessage)) : this.singleDay ? _react.default.createElement("div", {
        className: "session-date-range"
      }, _react.default.createElement("time", {
        className: "session-start session-end",
        dateTime: this.startDate
      }, this.startDate.format('F j'))) : _react.default.createElement("div", {
        className: "session-date-range"
      }, _react.default.createElement("time", {
        className: "session-start",
        dateTime: this.startDate
      }, this.startDate.format('F j')), ' - ', _react.default.createElement("time", {
        className: "session-end",
        dateTime: this.endDate
      }, this.endDate.format('F j'))), _react.default.createElement("div", {
        className: "session-title"
      }, this.session.title), this.purchase && _react.default.createElement("div", {
        className: "registration-info purchase-date"
      }, "Registered on on ", new Date(this.purchase.created * 1000).format('F j, Y')), !this.purchase && this.hasRegistrationRange && this.regStartDate.getTime() > Date.now() && _react.default.createElement("div", {
        className: "registration-info registration-waiting"
      }, "Registration opens on ", this.regStartDate.format('F j, Y')), !this.purchase && !this.hasRegistrationRange && this.endDate.getTime() > Date.now() && _react.default.createElement("div", {
        className: "registration-info registration-open"
      }, "Registration is open until ", this.endDate.format('F j, Y')), !this.purchase && this.hasRegistrationRange && this.regStartDate.getTime() <= Date.now() && this.regEndDate.getTime() > Date.now() && _react.default.createElement("div", {
        className: "registration-info registration-open"
      }, "Registration is open until ", this.regEndDate.format('F j, Y')), !this.purchase && this.hasRegistrationRange && this.regEndDate.getTime() <= Date.now() && _react.default.createElement("div", {
        className: "registration-info registration-closed"
      }, "Registration is now closed for this session."), !this.purchase && !this.hasRegistrationRange && this.endDate.getTime() <= Date.now() && _react.default.createElement("div", {
        className: "registration-info registration-closed"
      }, "Registration is now closed for this session.")), _react.default.createElement("div", {
        className: "session-registration"
      }, _react.default.createElement(SessionPeople, {
        people: this.people
      })), _react.default.createElement("div", {
        className: "session-buttons",
        style: {
          display: 'flex',
          flexDirection: this.media.matches ? 'column' : 'row'
        }
      }, this.showButton() && _react.default.createElement(_AnimatedComponent.default, {
        enter: this.state.outlineVisible,
        styleName: this.media.matches ? this.stylesMobile : this.stylesNotMobile,
        boxStyle: this.media.matches ? this.boxStyleMobile : this.boxStyleNotMobile,
        finishElementStyle: this.finishButtonStyle,
        format: this.buttonFormat,
        start: this.buttonMin,
        end: this.buttonMax
      }, _react.default.createElement(_ObjectDetailBar.ObjectDetailButton, this.button)), _react.default.createElement("a", {
        onClick: this.toggleOutline,
        className: "btn btn-dark",
        style: this.media.matches ? {
          order: '-1'
        } : {}
      }, "Details ", _react.default.createElement("span", {
        className: "caret",
        style: {
          transform: this.state.outlineVisible ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)'
        }
      })))), _react.default.createElement(CourseOutline, {
        course: this.link,
        visible: this.state.outlineVisible
      }));
    }
  }, {
    key: "toggleOutline",
    value: function toggleOutline() {
      this.setState(function (_ref2) {
        var outlineVisible = _ref2.outlineVisible;
        return {
          outlineVisible: !outlineVisible
        };
      });
    }
  }, {
    key: "singleDay",
    get: function get() {
      return this.startDate.format('Ymd') == this.endDate.format('Ymd');
    }
  }]);
  return ScheduledSessionLineItem;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "media", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.getMedia();
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "session", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "user", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "purchase", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "access", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "button", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "startDate", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Date(this.session.startDate * 1000);
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "endDate", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Date(this.session.endDate * 1000);
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "hasRegistrationRange", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return !!Number(this.session.hasRegistrationRange);
  }
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "regStartDate", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Date(this.session.registrationStartDate * 1000);
  }
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "regEndDate", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Date(this.session.registrationEndDate * 1000);
  }
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "dateIsNotConfirmed", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return !!Number(this.session.notConfirmed);
  }
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "dateMessage", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.session.dateMessage;
  }
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "buttonMin", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "buttonMin"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "buttonMax", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "buttonMax"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "buttonFormat", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "buttonFormat"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "finishButtonStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "finishButtonStyle"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "mediaChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "mediaChanged"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "toggleOutline", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "toggleOutline"), _class3.prototype)), _class3);
var CourseOutline = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(CourseOutline, _Component3);

  function CourseOutline() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, CourseOutline);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(CourseOutline)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "visible", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "course", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "error", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.state = {
      contentInit: false,
      promiseDone: false,
      bodyEntered: false,
      content: new Promise(function () {}) // Never resolved, this is fine.

    };
    return _this3;
  }

  babelHelpers.createClass(CourseOutline, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.visible != prevProps.visible) {
        if (this.visible && this.state.contentInit == false) {
          this.setState({
            contentInit: true,
            content: (0, _fetch.default)("".concat(this.course, "/navigation")).then(function (rv) {
              return rv.text();
            })
          });
        }
      }

      if (!prevState.promiseDone && this.state.promiseDone && !this.state.bodyEntered) this.setState({
        bodyEntered: true
      });
    }
  }, {
    key: "finishCourseListStyle",
    value: function finishCourseListStyle(el, state) {
      if (state) el.style.height = '';else el.style.height = '0px';
    }
  }, {
    key: "finishCourseListInnerStyle",
    value: function finishCourseListInnerStyle(el, state) {
      if (state) el.style.height = '';else el.style.height = "".concat(this.baseHeight, "px");
    }
  }, {
    key: "startPosition",
    value: function startPosition() {
      return {
        height: 0
      };
    }
  }, {
    key: "innerStartPosition",
    value: function innerStartPosition(el) {
      return {
        height: this.baseHeight || 0
      };
    }
  }, {
    key: "endPosition",
    value: function endPosition(el) {
      return {
        height: el.scrollHeight
      };
    }
  }, {
    key: "formatHeight",
    value: function formatHeight(h, name) {
      return "".concat(h, "px");
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_AnimatedComponent.default, {
        wrapperType: "footer",
        enter: this.visible,
        boxStyle: {
          overflow: 'hidden',
          height: '0px'
        },
        finishElementStyle: this.finishCourseListStyle,
        format: this.formatHeight,
        styleName: ['height'],
        start: this.startPosition,
        end: this.endPosition
      }, _react.default.createElement(_PromiseRenderer.default, {
        promise: this.state.content,
        success: this.promiseDone,
        pending: this.promisePending,
        error: this.promiseError
      }));
    }
  }, {
    key: "pendingElement",
    value: function pendingElement(node) {
      if (node) this.baseHeight = node.parentNode.scrollHeight;
    }
  }, {
    key: "promisePending",
    value: function promisePending() {
      return _react.default.createElement("div", {
        ref: this.pendingElement,
        className: "course-session-outline spinning",
        "data-spin": "true"
      });
    }
  }, {
    key: "promiseError",
    value: function promiseError() {
      return null;
    }
  }, {
    key: "promiseDone",
    value: function promiseDone(value) {
      var _this4 = this;

      if (!this.state.promiseDone) {
        setTimeout(function () {
          return _this4.setState({
            promiseDone: true
          });
        }, 0);
      }

      return _react.default.createElement(_AnimatedComponent.default, {
        wrapperType: "div",
        enter: this.state.bodyEntered,
        boxStyle: {
          overflow: 'hidden',
          height: this.baseHeight + 'px'
        },
        finishElementStyle: this.finishCourseListInnerStyle,
        format: this.formatHeight,
        styleName: ['height'],
        start: this.innerStartPosition,
        end: this.endPosition
      }, _react.default.createElement("div", {
        className: "course-session-outline",
        dangerouslySetInnerHTML: {
          __html: value
        },
        ref: this.gotOutline
      }));
    }
  }, {
    key: "gotOutline",
    value: function gotOutline(node) {
      if (node) [].forEach.call(node.querySelectorAll('[data-pie]'), _pie.default);
    }
  }]);
  return CourseOutline;
}(_react.Component), _temp3), (_descriptor17 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "visible", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "course", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "error", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "finishCourseListStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "finishCourseListStyle"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "finishCourseListInnerStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "finishCourseListInnerStyle"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "startPosition", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "startPosition"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "innerStartPosition", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "innerStartPosition"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "endPosition", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "endPosition"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "formatHeight", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "formatHeight"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "pendingElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "pendingElement"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "promisePending", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "promisePending"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "promiseError", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "promiseError"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "promiseDone", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "promiseDone"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotOutline", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotOutline"), _class5.prototype)), _class5);
var OneOnOneSessionLineItem = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(OneOnOneSessionLineItem, _Component4);

  function OneOnOneSessionLineItem() {
    var _babelHelpers$getProt4;

    var _this5;

    babelHelpers.classCallCheck(this, OneOnOneSessionLineItem);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(OneOnOneSessionLineItem)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "session", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "user", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "purchase", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "access", _descriptor23, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "people", _descriptor24, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "button", _descriptor25, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "link", _descriptor26, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "media", _descriptor27, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5.state = {
      outlineVisible: false,
      count: 0
    };
    _this5.boxStyleMobile = {
      overflow: 'hidden',
      width: '',
      height: '0px',
      opacity: 0,
      marginTop: 0
    };
    _this5.stylesMobile = ['height', 'opacity', 'marginTop'];
    _this5.boxStyleNotMobile = {
      overflow: 'hidden',
      width: '0px',
      height: '',
      opacity: 0
    };
    _this5.stylesNotMobile = ['width', 'opacity'];
    return _this5;
  }

  babelHelpers.createClass(OneOnOneSessionLineItem, [{
    key: "getMedia",
    value: function getMedia() {
      try {
        return window.matchMedia('(max-width: 767px)');
      } catch (e) {
        return {
          matches: true,
          addListener: function addListener() {},
          removeListener: function removeListener() {}
        };
      }
    }
  }, {
    key: "toggleOutline",
    value: function toggleOutline() {
      this.setState(function (_ref3) {
        var outlineVisible = _ref3.outlineVisible;
        return {
          outlineVisible: !outlineVisible
        };
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.media.addListener(this.mediaChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.media.removeListener(this.mediaChanged);
    }
  }, {
    key: "buttonMin",
    value: function buttonMin(element) {
      if (this.media.matches) return {
        height: 0,
        opacity: 0,
        marginTop: 0
      };
      return {
        width: 0,
        opacity: 0
      };
    }
  }, {
    key: "buttonMax",
    value: function buttonMax(element) {
      if (this.media.matches) return {
        height: element.style.height != '0px' ? element.offsetHeight : element.scrollHeight,
        opacity: 1,
        marginTop: 1
      };
      return {
        width: element.style.width != '0px' ? element.offsetWidth : element.scrollWidth,
        opacity: 1
      };
    }
  }, {
    key: "buttonFormat",
    value: function buttonFormat(value, name) {
      if (name == 'opacity') return value;

      if (name == 'marginTop') {
        return _compat.Info.cssVariables ? "calc(var(--scalable-unit, 16px) * ".concat(value, " * (24 / 16))") : value * 10 + 'px';
      }

      return "".concat(value, "px");
    }
  }, {
    key: "finishButtonStyle",
    value: function finishButtonStyle(button, targetState) {
      if (!targetState) {
        button.style[this.media.matches ? 'height' : 'width'] = '0px';
        button.style.opacity = 0;
        button.style.marginTop = this.media.matches ? '0px' : '';
      } else {
        button.style.width = button.style.height = '';
        button.style.opacity = 1;

        if (this.media.matches) {
          if (_compat.Info.cssVariables) button.style.marginTop = 'calc(var(--scalable-unit, 16px) * 24 / 16)';else button.style.marginTop = '24px';
        } else {
          button.style.marginTop = '';
        }
      }
    }
  }, {
    key: "mediaChanged",
    value: function mediaChanged() {
      this.setState(function (_ref4) {
        var count = _ref4.count;
        return {
          count: count + 1
        };
      });
    }
  }, {
    key: "showButton",
    value: function showButton() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("section", {
        className: "course-session one-on-one"
      }, _react.default.createElement("div", {
        className: "main"
      }, _react.default.createElement("div", {
        className: "session-info"
      }, _react.default.createElement("div", {
        className: "session-title"
      }, "Your Session"), _react.default.createElement("div", {
        className: "registration-info purchase-date"
      }, "Registered on on ", new Date(this.purchase.created * 1000).format('F j, Y'))), _react.default.createElement("div", {
        className: "session-registration"
      }, _react.default.createElement(SessionPeople, {
        people: this.people
      })), _react.default.createElement("div", {
        className: "session-buttons",
        style: {
          display: 'flex',
          flexDirection: this.media.matches ? 'column' : 'row'
        }
      }, this.showButton() && _react.default.createElement(_AnimatedComponent.default, {
        enter: this.state.outlineVisible,
        styleName: this.media.matches ? this.stylesMobile : this.stylesNotMobile,
        boxStyle: this.media.matches ? this.boxStyleMobile : this.boxStyleNotMobile,
        finishElementStyle: this.finishButtonStyle,
        format: this.buttonFormat,
        start: this.buttonMin,
        end: this.buttonMax
      }, _react.default.createElement(_ObjectDetailBar.ObjectDetailButton, this.button)), _react.default.createElement("a", {
        onClick: this.toggleOutline,
        className: "btn btn-dark",
        style: this.media.matches ? {
          order: '-1'
        } : {}
      }, "Details ", _react.default.createElement("span", {
        className: "caret",
        style: {
          transform: this.state.outlineVisible ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)'
        }
      })))), _react.default.createElement(CourseOutline, {
        course: this.link,
        visible: this.state.outlineVisible
      }));
    }
  }]);
  return OneOnOneSessionLineItem;
}(_react.Component), _temp4), (_descriptor20 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "session", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "user", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "purchase", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "access", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "button", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "media", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.getMedia();
  }
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "toggleOutline", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "toggleOutline"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "buttonMin", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "buttonMin"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "buttonMax", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "buttonMax"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "buttonFormat", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "buttonFormat"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "finishButtonStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "finishButtonStyle"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "mediaChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "mediaChanged"), _class7.prototype)), _class7);
var SessionPeople = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(SessionPeople, _Component5);

  function SessionPeople() {
    var _babelHelpers$getProt5;

    var _this6;

    babelHelpers.classCallCheck(this, SessionPeople);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(SessionPeople)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "people", _descriptor28, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(SessionPeople, [{
    key: "render",
    value: function render() {
      if (this.people && this.people.length) {
        return _react.default.createElement("div", {
          className: "session-people"
        }, _react.default.createElement(SessionPerson, {
          person: this.people[0].person
        }), this.people.length > 1 && _react.default.createElement("div", {
          className: "session-more"
        }, _react.default.createElement("div", {
          className: "more-label"
        }, "+ ", this.people.length - 1), false && _react.default.createElement("div", {
          className: "more"
        }, this.people.slice(1).map(function (v, i) {
          return _react.default.createElement(SessionPerson, {
            person: v.person,
            key: i
          });
        }))));
      }

      return null;
    }
  }]);
  return SessionPeople;
}(_react.Component), _temp5), (_descriptor28 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);
var SessionPerson = (_class11 = (_temp6 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(SessionPerson, _Component6);

  function SessionPerson() {
    var _babelHelpers$getProt6;

    var _this7;

    babelHelpers.classCallCheck(this, SessionPerson);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt6 = babelHelpers.getPrototypeOf(SessionPerson)).call.apply(_babelHelpers$getProt6, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "person", _descriptor29, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    return _this7;
  }

  babelHelpers.createClass(SessionPerson, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "session-person"
      }, this.person.photo_name && _react.default.createElement("div", {
        className: "icon",
        style: {
          backgroundImage: "url(".concat(this.person.photo_name, ")")
        }
      }), _react.default.createElement("div", {
        className: "name"
      }, this.person.nickname || this.person.fullName));
    }
  }]);
  return SessionPerson;
}(_react.Component), _temp6), (_descriptor29 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "person", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class11);